import { Button, Col, Container, Row, Spinner } from "reactstrap";
// import jsk from "../../../../src/assets/images/jsk.png";
import { FaUserCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import ClubInfo from "./componants/ClubInfo";
// import AnnonceItem from "pages/Annonces/components/AnnonceItem";
import { useDispatch, useSelector } from "react-redux";
import { getProfile } from "store/slices/clubSlice";
import EditClubProfile from "./EditClubProfile";
import { API_URL } from "constants/ApiUrl";
import Notifications from "pages/notifications/Notifications";
import { useSearchParams } from "react-router-dom";
import AnnoceListComponent from "pages/Annonces/annonceList/AnnoceListComponent";
import VerifieCompteClub from "./componants/VerifieCompteClub";

const ClubProfile = () => {
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab');
  const dispatch = useDispatch();
  const { club, loading, error } = useSelector((state) => state.Club);
  const [profileImage, setProfileImage] = useState(null)
  const role = localStorage.getItem("role");
  useEffect(() => {
    if (role === "club") {
      dispatch(getProfile());
    }
  }, []);
  useEffect(() => {
    if (club?.logo) {
      const cleanApiUrl = API_URL.replace(/\/+$/, '');

      let cleanLogo = club.logo.replace(/\\/g, '/').replace(/^\/+/, '');

      if (!cleanLogo.startsWith('uploads/')) {
        cleanLogo = 'uploads/' + cleanLogo;
      }
      setProfileImage(`${cleanApiUrl}/${cleanLogo}`);
    }

  }, [club]);
  const [mode, setMode] = useState("view");
  // const annonces = annoncements ? annoncements?.announcements : null;
  // const annonces = [
  //   {
  //     id: 1,
  //     titre: "Recrutement gardien de but",
  //     status: "Publié",
  //     datePublication: "2024-01-30",
  //     nombreVue: 150,
  //   },
  //   {
  //     id: 2,
  //     titre: "Annonce 2",
  //     status: "En attente",
  //     datePublication: "2024-01-28",
  //     nombreVue: 85,
  //   },

  //   {
  //     id: 3,
  //     titre: "Annonce 3",
  //     status: "Validé",
  //     datePublication: "2024-01-28",
  //     nombreVue: 1444,
  //   },
  // ];

  const [visibleCompanant, setVisibleCompanant] = useState("profile");
  useEffect(() => {
    setVisibleCompanant(tab ? tab : "profile");
  }, [tab])

  return (
    <div className="page-content">
      <Container fluid style={{ maxWidth: "100%", }}>
        <div className="page-title-box">
          <Row>
            <Row
              className="d-flex justify-content-center "
              style={{ backgroundColor: "#F3F8F9" }}
            >
              <Col
                md="8"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div
                  className="d-flex align-items-center mb-4 "
                  style={{ width: "50%" }}
                >
                  <div className="me-3">
                    {
                      profileImage ?
                        <img
                          src={profileImage}
                          alt="profileImage"
                          className="img-fluid"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "contain",
                          }}
                        />
                        :
                        <FaUserCircle size={64} className="text-secondary" />
                    }
                  </div>
                  <div>
                    <h5
                      className="mb-1"
                      style={{ font: "Visby CF", color: "#000000" }}
                    >
                      {club?.nameFr}
                    </h5>
                    <p className="text-muted mb-2">
                      Actif depuis {club?.createdAt && new Intl.DateTimeFormat('fr-FR', { month: 'long', year: 'numeric' }).format(new Date(club.createdAt))}
                    </p>

                    <Button
                      style={{
                        backgroundColor: "#157088B2",
                        color: "#ffffff",
                        font: "Visby CF",
                        borderRadius: 5,
                      }}
                      className="btn btn-primary btn-sm"
                      onClick={() => { setMode("edit"); setVisibleCompanant("profile"); }}
                    >
                      Modifier le profile
                    </Button>
                  </div>
                </div>
                <div style={{ width: "30%" }}>
                  <p
                    style={{ font: "Visby CF", color: "#000000", fontSize: 15 }}
                  >
                    Pour garantir la fiabilité et la sécurité sur la plateforme,
                    nous vous demandons de vérifier votre compte.
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      // justifyContent: "center",
                      marginBottom: 20,
                    }}
                  >
                    <VerifieCompteClub />
                  </div>
                </div>
              </Col>
            </Row>

            {/* button */}
            <div
              style={{
                marginTop: 10,
                display: "flex",
                flexWrap: "wrap",
                gap: "15px",
                justifyContent: "flex-start",
                paddingLeft: "30px",
              }}
            >
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "profile" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("profile")}
              >
                Profile
              </Button>
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "mesAnnonces" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("mesAnnonces")}
              >
                mes Annonces
              </Button>
              {/* <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "réglages" && { opacity: "50%" }),
                }}
                onClick={() => setVisibleCompanant("réglages")}
              >
                Réglages
              </Button> */}
              <Button
                style={{
                  background: "white",
                  border: "none",
                  color: "black",
                  cursor: "pointer",
                  fontSize: "14px",
                  ...(visibleCompanant === "notifications" && {
                    opacity: "50%",
                  }),
                }}
                onClick={() => setVisibleCompanant("notifications")}
              >
                Notifications
              </Button>
            </div>
            <hr
              style={{
                marginTop: "10px",
                borderColor: "EAEAEA",
                borderWidth: "2px",
                marginBottom: 50,
              }}
            />

            {mode === "view" && visibleCompanant === "profile" && <ClubInfo />}
            {mode === "edit" && visibleCompanant === "profile" && (
              <EditClubProfile onCancel={() => setMode("view")} />
            )}
            {visibleCompanant === "mesAnnonces" &&
              // <div>
              //   {!annonces ? (
              //     <div className="text-center my-5">
              //       <Spinner color="primary" />
              //     </div>
              //   ) : (
              //     annonces.map((annonce, key) => (
              //       <AnnonceItem annonce={annonce} key={key} />
              //     ))
              //   )}
              // </div>
              <div style={{ width: "100%", padding: "0", margin: "0" }}>
                <AnnoceListComponent />
              </div>

            }
            {visibleCompanant === "notifications" &&
              <Notifications />
            }
          </Row>
        </div>
      </Container>
    </div>
  );
};

export default ClubProfile;
